import Cookies from 'js-cookie'

import {signupFunnelSignalEvent} from '@/analytics/segment'
import {bigformCompleted} from '@/components/lead-form/tracking'
import {paramCookiesMap} from '@/config/cookies'
import CompanySize from '@/types/company-size'
import {isGenericEmail} from '@/utils/is-generic-email'

import type {State as HubspotFormState} from '@/components/hubspot-form'

export {bigformInteracted, bigformReached} from '@/components/lead-form/tracking'

const getCompanySizeAnalyticsValue = (companySize: CompanySize) => {
    switch (companySize) {
        case CompanySize.Size_10:
            return 2398
        case CompanySize.Size_50:
            return 3970
        case CompanySize.Size_100:
            return 8656
        case CompanySize.Size_250:
            return 6820
        case CompanySize.Size_500:
            return 8252
        default:
            return 1704
    }
}

export const ebookFormSubmitted = (state: HubspotFormState) => {
    bigformCompleted(state)

    if (!isGenericEmail(state.email)) {
        signupFunnelSignalEvent({
            fbc: Cookies.get(paramCookiesMap.metaClickId) || '',
            fbp: Cookies.get(paramCookiesMap.metaBrowserId) || '',
            gclid: Cookies.get(paramCookiesMap.googleClickIdentifier) || '',
            conversion_flow: 'ebook_form',
            company_size: state.companySize,
            li_fat_id: Cookies.get(paramCookiesMap.linkedinClickId) || '',
            currency: 'EUR',
            value: getCompanySizeAnalyticsValue(state.companySize),
        })
    }
}
